import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { Modal, ModalBody, Row, Col } from "reactstrap";
import styled from "styled-components";

import IconClose from "../../images/close-button-black.png";
import { Button } from "../Forms";

const ModalRaffleAlert = props => {
  return (
    <Modal
      toggle={props.onToggle}
      modalClassName="kick-notification-wrapper"
      isOpen={props.isOpen}
      className="kick-modal modal-notification"
    >
      <CloseWrapper onClick={props.onToggle}>
        <KickImage src={IconClose} alt="close-button-black.png" />
      </CloseWrapper>

      <ModalBody>
        <Col>
          {props.children}
          {props.showButton ? (
            <DecisionWrapper>
              <Button className="btn-white flat" onClick={props.onSubmit}>
                Yes
              </Button>
              <NoWrapper onClick={props.onToggle}>
                <span>No, cancel</span>
              </NoWrapper>
            </DecisionWrapper>
          ) : null}
        </Col>
      </ModalBody>
    </Modal>
  );
};

const CloseWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  img {
    width: 15px;
    height: 15px;
    cursor: pointer;
  }
`;

const DecisionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .btn-white {
    width: 50% !important;
  }
`;

const NoWrapper = styled.div`
  margin-top: 0.5rem;
  span {
    color: #ff1200;
    text-decoration: underline;
    text-align: center;
    cursor: pointer;
  }
`;

export default ModalRaffleAlert;
